import React, { useState } from 'react';
import './Login.css';
import LoginField from '../../components/login/LoginField';
import { login } from '../../API/functions';
import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const token = await login(email, password);
      localStorage.setItem('token', token);
      toast.success('Logged in successfully', {
        position: "bottom-right",
        draggable: true,
        transition: Bounce,
      });
      setError('');
      window.location.reload()
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleLogin} className="login-form">
        <div className="login-header">
          <img src={process.env.PUBLIC_URL + '/tree.png'} alt="decorative branches" className="login-branches" />
          <h2>Log In</h2>
        </div>
        <LoginField
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <LoginField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="error">{error}</p>}
        <button type="submit" className="login-button">Done</button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Login;
